var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/urls.j2"] = require( "macros/urls.j2" );
dependencies["macros/product-badge-macros.j2"] = require( "macros/product-badge-macros.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["product/templates/product-meta/web-exclusive-badge.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/urls.j2", false, "product/templates/product-meta/web-exclusive-badge.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("quickshopUrl")) {
var t_4 = t_1.quickshopUrl;
} else {
cb(new Error("cannot import 'quickshopUrl'")); return;
}
context.setVariable("quickshopUrl", t_4);
if(t_1.hasOwnProperty("productUrl")) {
var t_5 = t_1.productUrl;
} else {
cb(new Error("cannot import 'productUrl'")); return;
}
context.setVariable("productUrl", t_5);
if(t_1.hasOwnProperty("brandsUrl")) {
var t_6 = t_1.brandsUrl;
} else {
cb(new Error("cannot import 'brandsUrl'")); return;
}
context.setVariable("brandsUrl", t_6);
output += "\n\n\n";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"product")),"webExclusive") && !runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "quickshop")),"hideBadges")) {
env.getTemplate("macros/product-badge-macros.j2", false, "product/templates/product-meta/web-exclusive-badge.j2", false, function(t_8,t_7) {
if(t_8) { cb(t_8); return; }
t_7.getExported(context.getVariables(), frame, function(t_9,t_7) {
if(t_9) { cb(t_9); return; }
if(t_7.hasOwnProperty("webExclusive")) {
var t_10 = t_7.webExclusive;
} else {
cb(new Error("cannot import 'webExclusive'")); return;
}
context.setVariable("webExclusive", t_10);
output += runtime.suppressValue((lineno = 7, colno = 17, runtime.callWrap(t_10, "webExclusive", context, [runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"product")])), env.opts.autoescape);
output += "\n\n";
})});
}
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["product/templates/product-meta/web-exclusive-badge.j2"] , dependencies)